import { useMytaverse } from '../../providers/MytaverseProvider';
import { COLORS } from '../../constants/colors';

import { ILoadingProgressStyles } from './interfaces';
import { IStyles } from '../../interfaces/styles';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces/index';

export const useStyles = ({
  fullHeight,
  height,
}: ILoadingProgressStyles): IStyles => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: fullHeight ? '100vh' : height,
      [breakpoints.down(ScreenSizes.Tablet)]: {
        height: fullHeight ? '100vh' : '60vh',
      },
    },
    spinner: {
      color: appTheme?.mainColor ?? COLORS.MYTAVERSE_BLUE,
    },
  };
};
